import React, { Fragment } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { bool, func, string } from 'prop-types';

const propTypes = {
  sendFeedback: func.isRequired,
  openForm: func.isRequired,
  loading: bool.isRequired,
  language: string.isRequired,
};

const defaultProps = {
  loading: false,
};

const FaqFeedbackButtons = ({ sendFeedback, openForm, loading }) => (
  <Fragment>
    <span className="faq-feedback-title">
      <FormattedMessage id="faq.question" defaultMessage="Was this information helpful?" />
    </span>
    <div>
      <Button color="primary" size="sm" disabled={loading} onClick={() => sendFeedback(true)}>
        <FormattedMessage id="faq.yes" defaultMessage="Yes" />
      </Button>
      <Button size="sm" disabled={loading} onClick={openForm}>
        <FormattedMessage id="faq.no" defaultMessage="No" />
      </Button>
    </div>
  </Fragment>
);

FaqFeedbackButtons.propTypes = propTypes;
FaqFeedbackButtons.defaultProps = defaultProps;

const mapStateToProps = ({
  webmaster: {
    profile: { language },
  },
}) => ({ language });

export default connect(mapStateToProps)(FaqFeedbackButtons);
